import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-resourcetype",
  "use": "oc-res-resourcetype-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-resourcetype\"><path d=\"M65 62v896h896V62H65z m839.8 840H120.9V118h783.9v784z\" fill=\"#515151\" /><path d=\"M220.2 223.6v249.8H470V223.6H220.2zM414 417.4H276.2V279.6H414v137.8zM547.3 578.9h258.4v56H547.3zM220.2 546.6v249.8H470V546.6H220.2zM414 740.5H276.2V602.7H414v137.8zM540.3 385.1h258.4v56H540.3zM540.3 708.2h258.4v56H540.3zM547.3 255.8h258.4v56H547.3z\" fill=\"#515151\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol